import { localize } from "@/i18n/translate";
import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, errorCode } from "@/lib/api";
import { usePortal } from "../i18n";
import { Composer, Thread } from "../Messages";
import { refreshUnread } from "../Shell";
import { Badge, ErrorNote, Spinner } from "../ui";
export const TicketHeader = ({
  t,
  children
}) => {
  const {
    p,
    fmtDate
  } = usePortal();
  return <header className="border-b border-ink/15 pb-8">
      <div className="flex flex-wrap items-center gap-3">
        <span className="font-mono text-xs text-mute">{localize(p.dash.ref)} {localize(t.ref)}</span>
        <Badge value={t.status} label={p.ticket[t.status]} testId="ticket-status-badge" />
      </div>
      <h1 className="mt-4 break-words font-display text-2xl font-extrabold leading-[1.05] tracking-[-0.03em] sm:text-4xl" data-testid="ticket-subject">{localize(t.subject)}</h1>
      <dl className="mt-6 grid gap-4 text-sm sm:grid-cols-3">
        <div><dt className="eyebrow">{localize(p.thread.category)}</dt><dd className="mt-1">{localize(p.categories[t.category])}</dd></div>
        <div><dt className="eyebrow">{localize(p.thread.created)}</dt><dd className="mt-1">{localize(fmtDate(t.created_at))}</dd></div>
        {localize(children)}
      </dl>
    </header>;
};
export default function ClientTicket() {
  const {
    id
  } = useParams();
  const {
    p,
    errText
  } = usePortal();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => {
    api.get(`/portal/tickets/${id}`).then(r => {
      setData(r.data);
      refreshUnread();
    }).catch(e => setErr(errText(errorCode(e))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  useEffect(() => {
    load();
  }, [load]);
  return <div data-testid="client-ticket-page">
      <Link to="/kundenbereich" className="mb-8 inline-flex items-center gap-2 text-sm font-medium hover:text-signal" data-testid="ticket-back-link"><ArrowLeft className="h-4 w-4" aria-hidden="true" /> {localize(p.thread.back)}</Link>
      <ErrorNote>{localize(err)}</ErrorNote>
      {localize(!data && !err && <Spinner label={p.loading} />)}
      {localize(data?.ticket && <>
          <TicketHeader t={data.ticket} />
          <h2 className="eyebrow mt-10">{localize(p.thread.conversation)}</h2>
          <div className="mt-4"><Thread messages={Array.isArray(data.messages) ? data.messages : []} viewer="client" /></div>
          {localize(data.ticket.status === "abgeschlossen" && <p className="mt-6 text-sm text-mute">{localize(p.thread.closedNote)}</p>)}
          <div className="mt-6"><Composer endpoint={`/portal/tickets/${id}/messages`} onSent={load} /></div>
        </>)}
    </div>;
}
